<!--
ExplainedCell — wraps one DataTable body cell in its per-row Explanation
(`column.cellExplanation(row)`, skill `self-explaining-ui`): the reason THIS row
shows what it shows ("Atrasado: prometido para 12/10, ainda em produção").

With no explanation for the row it renders the cell untouched — no wrapper
element, so rows without a reason keep exactly the markup they had.
-->

<template>
  <span v-if="explanation" v-explain.top="explanation" class="dt-cell-explained" tabindex="0">
    <slot />
  </span>
  <slot v-else />
</template>

<script setup lang="ts">
import type { ExplanationInput } from '../explanations/types';
import { vExplain } from '../explanations/vExplain';

defineOptions({ name: 'ExplainedCell' });

withDefaults(defineProps<{ explanation?: ExplanationInput }>(), { explanation: null });
</script>

<style scoped>
.dt-cell-explained {
  cursor: help;
  text-decoration: underline dotted var(--app-text-secondary-color);
  text-underline-offset: 3px;
}

.dt-cell-explained:focus-visible {
  outline: 2px solid var(--app-primary-color);
  outline-offset: 2px;
  border-radius: 2px;
}
</style>
